import React from 'react'

import { Outcome } from '@app/graphql/types'
import { CheckResultsLayout } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsLayout'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'

export type DistributionFormulaCheckResultsProps = {
  check: UtilityBillAnalysisChecks['distributionFormula']
}

export const DistributionFormulaCheckResults = ({
  check
}: DistributionFormulaCheckResultsProps) => {
  if (check.outcome === Outcome.Pass) {
    return null
  }

  return (
    <CheckResultsLayout>
      <CheckResultsLayout.Title>Verteilerschlüssel</CheckResultsLayout.Title>
      <CheckResultsLayout.Description>
        Der Verteiler- bzw. Umlageschlüssel wurde von der KI als falsch oder fragwürdig erkannt oder
        es wurde festgestellt, dass ein solcher gar nicht verwendet wurde.
      </CheckResultsLayout.Description>
    </CheckResultsLayout>
  )
}
